export const TRANSLATION_LANGUAGE_OPTIONS = [
  { labelKey: 'ai.languages.english', value: 'en' },
  { labelKey: 'ai.languages.spanish', value: 'es' },
  { labelKey: 'ai.languages.portuguese', value: 'pt' },
  { labelKey: 'ai.languages.french', value: 'fr' },
  { labelKey: 'ai.languages.german', value: 'de' },
  { labelKey: 'ai.languages.italian', value: 'it' },
] as const

export type TranslationLanguageCode = (typeof TRANSLATION_LANGUAGE_OPTIONS)[number]['value']
